import { render, staticRenderFns } from "./LabelModal6a2.vue?vue&type=template&id=5110ca60&scoped=true&"
import script from "./LabelModal6a2.vue?vue&type=script&lang=js&"
export * from "./LabelModal6a2.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal6a2.vue?vue&type=style&index=0&id=5110ca60&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal6a2.vue?vue&type=style&index=1&id=5110ca60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110ca60",
  null
  
)

export default component.exports